export enum ActionType {
    Loaded,
    Added,
    Deleted
}